import {
  DocumentData,
  DocumentReference,
  DocumentSnapshot,
  Timestamp,
  Transaction,
  Unsubscribe,
  deleteDoc,
  doc,
  onSnapshot,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { firestore } from "../../../firebase";

export function getDocumentRef(
  path: string,
  uid: string,
  converter?: any
): DocumentReference<DocumentData> {
  if (uid) {
    const docRef = doc(firestore, path, uid).withConverter(converter);
    if (docRef) return docRef;
  }

  throw new Error("Document not found");
}

export async function setDocument(
  doc: DocumentReference<DocumentData>,
  updatedData: any,
  transaction?: Transaction
): Promise<void> {
  if (transaction) {
    transaction.set(doc, updatedData);
    return;
  }
  return setDoc(doc, updatedData);
}

export async function updateDocument(
  doc: DocumentReference<DocumentData>,
  updatedData: any,
  transaction?: Transaction
): Promise<void> {
  updatedData.modifiedAt = Timestamp.now();

  if (transaction) {
    transaction.update(doc, updatedData);
    return;
  }
  return updateDoc(doc, updatedData);
}

export async function deleteDocument(
  doc: DocumentReference<DocumentData>,
  transaction?: Transaction
): Promise<void> {
  if (transaction) {
    transaction.delete(doc);
    return;
  }
  return deleteDoc(doc);
}

export function onDocumentSnapshot<T>(
  doc: DocumentReference<DocumentData>,
  onCreate: (data: T) => void,
  onChange: (data: T) => void,
  onError: (error) => void
): Unsubscribe {
  let firstSnapshot = true;
  return onSnapshot(
    doc,
    (snapshot: DocumentSnapshot<DocumentData>) => {
      const data = snapshot.data() as T;

      if (firstSnapshot) {
        firstSnapshot = false;
        onCreate(data);
      } else onChange(data);
    },
    onError
  );
}
